module.exports = __webpack_public_path__ + "static/media/lumbering19.28d8a70a.jpg";